export default __webpack_public_path__ + "static/media/logo_kustomer.66ce77ee.svg";